/**
 * @file payDialogBridge.js
 * @description 购卷 / 充值 / 协议弹窗跨 feature 打开入口，避免 feature 互引
 * @module shared/utils/payDialogBridge
 */

/** @type {((ctx: object) => boolean)|null} */
let openVolPayImpl = null
/** @type {((ctx: object) => boolean)|null} */
let openGoldRechargeImpl = null
/** @type {((code: string) => void)|null} */
let openAgreementImpl = null
/** @type {(() => Promise<boolean>)|null} */
let retryVolPayImpl = null
/** @type {((payload: object) => Promise<object>)|null} */
let volPayRechargePreviewImpl = null

/**
 * @param {(ctx: object) => boolean} fn
 */
export function registerVolPayOpener(fn) {
  openVolPayImpl = fn
}

/**
 * @param {object} ctx
 * @returns {boolean}
 */
export function requestOpenVolPay(ctx) {
  return openVolPayImpl ? openVolPayImpl(ctx) : false
}

/**
 * @param {(ctx: object) => boolean} fn
 */
export function registerGoldRechargeOpener(fn) {
  openGoldRechargeImpl = fn
}

/**
 * @param {object} ctx
 * @returns {boolean}
 */
export function requestOpenGoldRecharge(ctx) {
  return openGoldRechargeImpl ? openGoldRechargeImpl(ctx) : false
}

/**
 * @param {(code: string) => void} fn
 */
export function registerAgreementOpener(fn) {
  openAgreementImpl = fn
}

/**
 * @param {string} code
 */
export function requestOpenAgreement(code) {
  if (openAgreementImpl) openAgreementImpl(code)
}

/**
 * @param {() => Promise<boolean>} fn
 */
export function registerVolPayRetry(fn) {
  retryVolPayImpl = fn
}

/**
 * @returns {Promise<boolean>}
 */
export async function requestRetryVolPayAfterRecharge() {
  if (!retryVolPayImpl) return false
  return retryVolPayImpl()
}

/**
 * @param {(payload: object) => Promise<object>} fn
 */
export function registerVolPayRechargePreview(fn) {
  volPayRechargePreviewImpl = fn
}

/**
 * @param {{ comicId: string, volId: string, bulkType?: string }} payload
 * @returns {Promise<object|null>}
 */
export async function requestVolPayRechargePreview(payload) {
  if (!volPayRechargePreviewImpl) return null
  return volPayRechargePreviewImpl(payload)
}
